module.exports = __webpack_public_path__ + "img/9.52c0eb08.png";